// client/src/components/lookup/Table.tsx
import React from 'react';
import { Lookup, LookupCategory } from '../../../types/lookup';

interface TableProps {
  data: Lookup[];
  category: LookupCategory;
  onToggle: (item: Lookup) => void;
  onEdit: (item: Lookup) => void;
}

export const Table: React.FC<TableProps> = ({ data, category, onToggle, onEdit }) => {
  if (data.length === 0) {
    return <p className="theme-text-secondary">No items found.</p>;
  }

  return (
    <div className="mt-8 flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden shadow ring-1 ring-white/10 sm:rounded-lg">
            <table className="min-w-full divide-y divide-white/10">
              <thead className="glass-card-light">
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold theme-text-primary sm:pl-6">
                    Value
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold theme-text-primary">
                    Display Name
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold theme-text-primary">
                    Sort Order
                  </th>
                  {category === 'organisations' && (
                    <>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold theme-text-primary">
                        Session Rate
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold theme-text-primary">
                        Number of Sessions
                      </th>
                    </>
                  )}
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold theme-text-primary">
                    Status
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span className="sr-only">Actions</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/10">
                {data.map((item) => (
                  <tr key={item._id || item.value}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium theme-text-primary sm:pl-6">
                      {item.value}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm theme-text-secondary">
                      {item.displayName}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm theme-text-secondary">
                      {item.sortOrder || '-'}
                    </td>
                    {category === 'organisations' && (
                      <>
                        <td className="whitespace-nowrap px-3 py-4 text-sm theme-text-secondary">
                          £{item.sessionRate}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm theme-text-secondary">
                          {item.numberOfSessions}
                        </td>
                      </>
                    )}
                    <td className="whitespace-nowrap px-3 py-4 text-sm theme-text-secondary">
                      <span className={`inline-flex rounded-full px-2 text-xs font-semibold leading-5 ${
                        item.active 
                          ? 'bg-green-500/20 text-green-300' 
                          : 'bg-red-500/20 text-red-300'
                      }`}>
                        {item.active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                      <div className="flex justify-end space-x-2">
                        <button
                          onClick={() => onEdit(item)}
                          className="text-blue-300 hover:text-blue-200 font-semibold transition-colors"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => onToggle(item)}
                          className={`font-semibold transition-colors ${
                            item.active 
                              ? 'text-red-300 hover:text-red-200' 
                              : 'text-green-300 hover:text-green-200'
                          }`}
                        >
                          {item.active ? 'Deactivate' : 'Activate'}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};